<template>
	<div>
		<CContainer>
			<CRow>
				<CCol class="container-intro col-12 text-center">
					<img src="img/bnn-logo.svg">
					<p>
						{{ $t('message.login_page_intro') }}
					</p>
				</CCol>
				<CCol class="col-12">
					<CForm class="container-login-form" @submit.prevent="handleSubmit">
						<h3 class="container-login-form-heading">
							{{ $t("message.login") }}
						</h3>
						<CInput
							v-model.trim="$v.username.$model"
							:is-valid="formState.username.valid"
							:invalid-feedback="formState.username.error"
							placeholder="Username"
							autocomplete="username email"
							class="container-login-form-input"
						>
							<template #prepend-content>
								<CIcon name="cil-user" />
							</template>
						</CInput>
						<CInput
							v-model.trim="$v.password.$model"
							:is-valid="formState.password.valid"
							:invalid-feedback="formState.password.error"
							type="password"
							placeholder="Password"
							autocomplete="curent-password"
							class="container-login-form-input"
						>
							<template #prepend-content>
								<CIcon name="cil-lock-locked" />
							</template>
						</CInput>
						<div class="text-center">
							<CButton
								:disabled="isLoading"
								type="submit"
								color="primary"
								class="submit-button px-4"
							>
								{{ $t("button.login") }}
							</CButton>
						</div>
					</CForm>
				</CCol>
			</CRow>
		</CContainer>
	</div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { required, minLength } from 'vuelidate/lib/validators';
import { inputStateValid, inputStateError } from '../helpers/vuelidator';
import { ROUTER_NAME } from '../enums/router';

export default {
	name: 'Login',

	data() {
		return {
			username: null,
			password: null,
		};
	},

	validations: {
		username: {
			required,
		},
		password: {
			required,
			minLength: minLength(8),
		},
	},

	computed: {
		...mapState('auth', {
			isLoading: 'isLoading',
			isLoginError: 'isLoginError',
		}),
		formState() {
			return {
				username: {
					valid: inputStateValid(this.$v.username),
					error: inputStateError(this.$v.username)(this),
				},
				password: {
					valid: (() => {
						if (this.isLoginError) {
							return false;
						}
						return inputStateValid(this.$v.password);
					})(),
					error: (() => {
						if (this.isLoginError) {
							return this.$t('message.login_error');
						}
						return inputStateError(this.$v.password)(this);
					})(),
				},
			};
		},
	},

	watch: {
		username() {
			this.clearLoginError();
		},
		password() {
			this.clearLoginError();
		},
	},

	methods: {
		...mapActions('auth', {
			login: 'login',
			clearLoginError: 'clearLoginError',
		}),
		async handleSubmit() {
			this.$v.$touch();

			const isValidForm = !this.$v.$invalid;

			if (isValidForm) {
				await this.login({
					username: this.username,
					password: this.password,
				});

				if (!this.isLoginError) {
					// redirect to dashboard pages
					this.$router.push({ name: ROUTER_NAME.DASHBOARD });
				}
			}
		},

	},
};
</script>

<style lang="scss" scoped>
$container-width: rem(444);

.container-intro {
	width: $container-width;
	margin: rem(40) auto 0;

	p {
		@include typo-h6;

		margin-top: rem(4);
		color: $color-black-45;
	}
}

.container-login-form {
	width: $container-width;
	margin: rem(110) auto 0;

	// .container-login-heading
	&-heading {
		margin-bottom: 1em;
		text-align: center;
	}

	// .container-login-input
	&-input {
		margin-bottom: rem(20);

		// overwrite hide append icon
		::v-deep .is-invalid {
			background-image: none;
		}
	}

	.submit-button {
		min-width: rem(132);
	}
}
</style>
